import React,{useState} from 'react'
import Header from 'components/Headers/Header';
import {  Button,  Card,  CardHeader,  CardBody,  FormGroup,  Form,  Input,Container,Row,  Col, CardFooter,Label} from "reactstrap";
import { newUser } from 'network/ApiAxios';

function CreateNewUser() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [cardID, setCardID] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [notice, setNotice] = useState({});

    const userRole = JSON.parse(localStorage.getItem('user')).role

    const handleCreate = async()=>{
        if(password != passwordConfirm || !password){
            setNotice({
                textColor : 'text-white bg-red mb-2',
                text: "Passwords don't match!!!"
            })
            handleNotice()
            return
        }
        if(password.length < 6){
            setNotice({
                textColor : 'text-white bg-red mb-2',
                text: "Password must be at least 6 characters long!!!"
            })
            handleNotice()
            return
        }
        if(!name || !email || !role){
            setNotice({
                textColor : 'text-white bg-red mb-2',
                text: "Please fill all mandatory fields!!!"
            })
            handleNotice()
            return
        }
        
        const resp = await newUser(name,email,password,role,cardID)
        if(resp.data.success){
            setNotice({
                textColor : 'text-blue bg-grey mb-2',
                text: resp.data.msg
            })
            handleNotice()
            setEmail('')
            setName('')
            setPassword('')
            setPasswordConfirm('')
            setCardID('')
        }else{
            setNotice({
                textColor : 'text-white bg-red mb-2',
                text: resp.data.msg
            })
            handleNotice()
        }
        
    }

    const handleNotice = ()=>{
        setInterval(() => {
            setNotice({})
        }, 3000);
    }
  return (
    <>
    {userRole == 'admin' && <Header/>}
    <Container  fluid>
        <Row className="justify-content-center">
            <Col className="order-xl-2 mb-5 mb-xl-0" xl="6">
                <Card className="card-profile shadow">
                    <CardHeader>
                        <h1>Create New User</h1>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col lg='6' className='mt-4'>
                                <Label for='input-name'>Name:</Label>
                                <Input id='input-name' value={name} onChange={(e)=> setName(e.target.value)}/>
                            </Col>
                            <Col lg='6' className='mt-4'>
                                <Label for='input-email'>Email:</Label>
                                <Input id='input-email' value={email} onChange={(e)=> setEmail(e.target.value)}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='6' className='mt-4'>
                                <Label for='select-role'>Role(handles website permissions):</Label>
                                <Input type="select" name="select" id="select-role" onChange={(e) => setRole(e.target.value)} required>
                                    <option>Select 1</option>
                                    <option>user</option>
                                    <option>seller</option>
                                    <option>shop</option>
                                    <option>manager</option>
                                    <option>sellermanager</option>
                                    <option>cleaner</option>
                                    <option>security</option>
                                </Input>
                            </Col>
                            <Col lg='6' className='mt-4'>
                                <Label for='input-card'>Card ID:</Label>
                                <Input id='input-card' value={cardID} onChange={(e)=> setCardID(e.target.value)}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='6' className='mt-4'>
                                <Label for='input-password'>Password:</Label>
                                <Input id='input-password' value={password} onChange={(e)=> setPassword(e.target.value)}/>
                            </Col>
                            <Col lg='6' className='mt-4'>
                                <Label for='input-confirm-password'>Confirm Password:</Label>
                                <Input id='input-confirm-password' value={passwordConfirm} onChange={(e)=> setPasswordConfirm(e.target.value)}/>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <Row className="justify-content-center d-flex">
                            {notice && <span className={notice.textColor}> {notice.text}</span>}
                        </Row>
                        <Row className="justify-content-center d-flex">
                            <Button className='btn-info' onClick={()=>handleCreate()}>Create</Button>
                        </Row>
                    </CardFooter>
                </Card>
            </Col>
        </Row>
    </Container>
    </>
  )
}

export default CreateNewUser